import {
  LayoutDashboard,
  UserCog,
  ShieldCheck,
  ClipboardList,
  IdCard,
  Users,
  Gamepad2,
  Dumbbell,
  Trophy,
  Swords,
  FolderInput,
  Upload,
  FileText,
  Globe,
  Settings,
  CreditCard,
  HelpCircle,
  Calendar,
  BookOpenText,
  ChevronUp,
  Eye,
  Filter,
  NotebookText,
  LogOut,
  Search,
  X,
  Trash2,
  Edit,
  ChevronLeft,
  ChevronRight,
  ChevronDownIcon,
  ChevronsLeft,
  ChevronsRight,
  UserStar,
  Banknote,
  BanknoteX,
  CalendarCheck,
  CalendarX,
  BadgeCheck,
  ShieldOff,
  ClockAlert,
  UserX,
  Copy,
  Calendar1,
  ShieldEllipsis,
  FileSliders,
  CircleGauge,
  Moon,
  Sun,
  Funnel,
  TriangleAlert,
  UserPen,
  KeyRound,
  EyeClosed,
  OctagonAlert,
  Check,
  SignalHigh,
  SendHorizontal,
  ArrowLeft,
  NotebookPen,
  BookMarked,
  Bot,
  House,
  RotateCcwKey,
  ShieldPlus,
  ChevronDown,
  ChevronsUpDown,
  NotepadText,
  Plus,
  Menu,
  PanelLeftOpen,
  Trash,
  RefreshCcw,
  Lock,
  LockOpen,
  EllipsisVertical,
  Smartphone,
  Monitor,
  Laptop,
  FileSpreadsheet,
  ShieldBan,
  Form,
  Dot,
  SlidersVertical,
  Columns3Cog,
  CirclePlay,
  Volleyball,
  Play,
  CircleDot,
  Star,
  CircleAlert,
  Tv,
  UserPlus,
  History,
  Share,
  Share2,
  MoveUp,
} from "lucide-react";

export const ICONS = {
  LayoutDashboard,
  UserCog,
  ShieldCheck,
  ClipboardList,
  IdCard,
  Users,
  Gamepad2,
  Dumbbell,
  Trophy,
  Swords,
  FolderInput,
  Upload,
  FileText,
  Globe,
  Settings,
  CreditCard,
  HelpCircle,
  Calendar,
  BookOpenText,
  ChevronUp,
  Eye,
  Filter,
  NotebookText,
  LogOut,
  Search,
  X,
  Trash2,
  Edit,
  ChevronLeft,
  ChevronRight,
  ChevronDownIcon,
  ChevronsLeft,
  ChevronsRight,
  UserStar,
  Banknote,
  BanknoteX,
  CalendarCheck,
  CalendarX,
  BadgeCheck,
  ShieldOff,
  ClockAlert,
  UserX,
  Copy,
  Calendar1,
  ShieldEllipsis,
  FileSliders,
  CircleGauge,
  Moon,
  Sun,
  Funnel,
  TriangleAlert,
  UserPen,
  KeyRound,
  EyeClosed,
  OctagonAlert,
  Check,
  SignalHigh,
  SendHorizontal,
  ArrowLeft,
  NotebookPen,
  BookMarked,
  Bot,
  House,
  RotateCcwKey,
  ShieldPlus,
  ChevronDown,
  ChevronsUpDown,
  NotepadText,
  Plus,
  Menu,
  PanelLeftOpen,
  Trash,
  RefreshCcw,
  Lock,
  LockOpen,
  EllipsisVertical,
  Smartphone,
  Monitor,
  Laptop,
  FileSpreadsheet,
  ShieldBan,
  Form,
  Dot,
  SlidersVertical,
  Columns3Cog,
  CirclePlay,
  Volleyball,
  Play,
  CircleDot,
  Star,
  CircleAlert,
  Tv,
  UserPlus,
  History,
  Share,
  Share2,
  MoveUp,
};

export const SPORTS_ICON = {
  inplay: "Play",
  cricket: "cricketIcon",
  football: "footballIcon",
  tennis: "tennisIcon",
  soccer: "footballIcon",
};
